// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
type Hex = `#${string}` | string;

export type ColorKey = keyof ColorPalette;

export interface ColorPalette {
  black0: Hex;
  black100: Hex;
  black150: Hex;
  black200: Hex;
  black300: Hex;
  black350: Hex;
  black400: Hex;
  black500: Hex;
  black600: Hex;
  blue0: Hex;
  blue100: Hex;
  blue150: Hex;
  blue200: Hex;
  blue300: Hex;
  blue400: Hex;
  blue500: Hex;
  blue600: Hex;
  blue700: Hex;
  blue85L: Hex;
  blue97L: Hex;
  brandBlue: Hex;
  brandNavy: Hex;
  green0: Hex;
  green100: Hex;
  green150: Hex;
  green200: Hex;
  green300: Hex;
  green400: Hex;
  green500: Hex;
  green600: Hex;
  red0: Hex;
  red100: Hex;
  red150: Hex;
  red200: Hex;
  red300: Hex;
  red400: Hex;
  red500: Hex;
  red600: Hex;
  statusBU100: Hex;
  statusBU200: Hex;
  statusBU300: Hex;
  statusBU400: Hex;
  statusBU500: Hex;
  statusGN100: Hex;
  statusGN200: Hex;
  statusGN300: Hex;
  statusGN400: Hex;
  statusGN500: Hex;
  statusRD100: Hex;
  statusRD200: Hex;
  statusRD300: Hex;
  statusRD400: Hex;
  statusRD500: Hex;
  statusYE100: Hex;
  statusYE200: Hex;
  statusYE300: Hex;
  statusYE400: Hex;
  statusYE500: Hex;
  triumphTeal100: Hex;
  triumphTeal200: Hex;
  triumphTeal300: Hex;
  triumphTeal400: Hex;
  triumphTeal50: Hex;
  triumphTeal500: Hex;
  triumphTeal600: Hex;
  triumphTeal700: Hex;
  triumphTeal800: Hex;
  triumphTeal900: Hex;
  yellow0: Hex;
  yellow100: Hex;
  yellow150: Hex;
  yellow200: Hex;
  yellow300: Hex;
  yellow400: Hex;
  yellow500: Hex;
  yellow600: Hex;

  /* eslint-disable typescript-sort-keys/interface, @typescript-eslint/naming-convention */
  v3_white_100: Hex;

  v3_navy_100: Hex;
  v3_navy_200: Hex;
  v3_navy_300: Hex;
  v3_navy_400: Hex;
  v3_navy_500: Hex;
  v3_navy_600: Hex;
  v3_navy_700: Hex;
  v3_navy_800: Hex;
  v3_navy_900: Hex;

  v3_gray_100: Hex;
  v3_gray_200: Hex;
  v3_gray_300: Hex;
  v3_gray_400: Hex;
  v3_gray_500: Hex;
  v3_gray_600: Hex;
  v3_gray_700: Hex;
  v3_gray_800: Hex;
  v3_gray_900: Hex;

  v3_blue_100: Hex;
  v3_blue_150: Hex;
  v3_blue_200: Hex;
  v3_blue_300: Hex;
  v3_blue_400: Hex;
  v3_blue_500: Hex;
  v3_blue_600: Hex;
  v3_blue_700: Hex;
  v3_blue_800: Hex;
  v3_blue_900: Hex;

  v3_green_100: Hex;
  v3_green_200: Hex;
  v3_green_300: Hex;
  v3_green_400: Hex;
  v3_green_500: Hex;
  v3_green_600: Hex;
  v3_green_700: Hex;

  v3_yellow_100: Hex;
  v3_yellow_200: Hex;
  v3_yellow_300: Hex;
  v3_yellow_400: Hex;
  v3_yellow_500: Hex;
  v3_yellow_600: Hex;
  v3_yellow_700: Hex;

  v3_red_100: Hex;
  v3_red_200: Hex;
  v3_red_300: Hex;
  v3_red_400: Hex;
  v3_red_500: Hex;
  v3_red_600: Hex;
  v3_red_700: Hex;
  v3_red_800: Hex;

  v3_teal_100: Hex;
  v3_teal_200: Hex;
  v3_teal_300: Hex;
  v3_teal_400: Hex;
  v3_teal_500: Hex;
  v3_teal_600: Hex;
  v3_teal_700: Hex;

  v3_pink_100: Hex;
  v3_pink_200: Hex;
  v3_pink_300: Hex;
  v3_pink_400: Hex;
  v3_pink_500: Hex;
  v3_pink_600: Hex;
  v3_pink_700: Hex;

  v3_violet_100: Hex;
  v3_violet_200: Hex;
  v3_violet_300: Hex;
  v3_violet_400: Hex;
  v3_violet_500: Hex;
  v3_violet_600: Hex;
  v3_violet_700: Hex;

  inherit: 'inherit';
  transparent: 'transparent';
  /* eslint-enable typescript-sort-keys/interface, @typescript-eslint/naming-convention */
}

/**
 * @deprecated use `semanticColors` instead
 */
export const colorPalette: ColorPalette = {
  black0: '#FFFFFF',
  black100: '#F2F5F7', // duplicate of 150
  black150: '#F2F5F7',
  black200: '#E8EAED',
  black300: '#E1E3E6',
  black350: '#C4C6C8',
  black400: '#A2A4A6',
  black500: '#898B8C',
  black600: '#27292D', // this isn't in figma
  blue0: '#FFFFFF',
  blue85L: '#C8D8EB',
  blue97L: '#F2F5FA',
  blue100: '#E1EAF4',
  blue150: '#C8D8EB',
  blue200: '#7DA1C4',
  blue300: '#446F97',
  blue400: '#003A70',
  blue500: '#0E3457',
  blue600: '#032749',
  blue700: '#011A32',
  brandBlue: '#0072CE',
  brandNavy: '#00263E', // v3
  green0: '#FFFFFF',
  green100: '#DFF9EA',
  green150: '#EFF4EB',
  green200: '#7EE0A7',
  green300: '#00C150',
  green400: '#009F42',
  green500: '#007C34',
  green600: '#497C16',
  red0: '#FFFFFF',
  red100: '#FFDDD7',
  red150: '#FAE9E9',
  red200: '#FFBAAE',
  red300: '#FF9886',
  red400: '#FF6449',
  red500: '#D11f00',
  red600: '#A70101',
  statusBU100: '#E0F1FF',
  statusBU200: '#8ECDFF',
  statusBU300: '#2BA0FF',
  statusBU400: '#0088F8',
  statusBU500: '#006FCA',
  statusGN100: '#DFF9EA',
  statusGN200: '#7EE0A7',
  statusGN300: '#00C150',
  statusGN400: '#009F42',
  statusGN500: '#007C34',
  statusRD100: '#FFDDD7',
  statusRD200: '#FFBAAE',
  statusRD300: '#FF9886',
  statusRD400: '#FF6449',
  statusRD500: '#D11F00',
  statusYE100: '#FFF3C9',
  statusYE200: '#FFE279',
  statusYE300: '#FFBD4A',
  statusYE400: '#FB9C23',
  statusYE500: '#BA4E00',
  triumphTeal50: 'hsl(189 63% 94%)',
  triumphTeal100: 'hsl(188 59% 87%)',
  triumphTeal200: 'hsl(188 59% 75%)',
  triumphTeal300: 'hsl(189 60% 63%)',
  triumphTeal400: 'hsl(189 60% 50%)',
  triumphTeal500: 'hsl(188 100% 37%)',
  triumphTeal600: 'hsl(191 100% 30%)',
  triumphTeal700: 'hsl(193 100% 24%)',
  triumphTeal800: 'hsl(198 100% 18%)',
  triumphTeal900: 'hsl(207 100% 12%)',
  yellow0: '#FFFFFF',
  yellow100: '#FFF3C9',
  yellow150: '#FFF9E7',
  yellow200: '#FFE279',
  yellow300: '#FFBD4A',
  yellow400: '#FB9C23',
  yellow500: '#BA4E00',
  yellow600: '#BA4E00',

  /* eslint-disable sort-keys, @typescript-eslint/naming-convention */
  v3_white_100: '#FFFFFF',

  v3_navy_100: '#F8F9FC',
  v3_navy_200: '#F3F5F9',
  v3_navy_300: '#E5EAF0',
  v3_navy_400: '#CFD9E4',
  v3_navy_500: '#8FA1B2',
  v3_navy_600: '#586E83',
  v3_navy_700: '#32485D',
  v3_navy_800: '#1A2C3D',
  v3_navy_900: '#041825',

  v3_gray_100: '#F2F5F7',
  v3_gray_200: '#E8EAED',
  v3_gray_300: '#E1E3E6',
  v3_gray_400: '#C4C6C8',
  v3_gray_500: '#A2A4A6',
  v3_gray_600: '#898B8C',
  v3_gray_700: '#53565A',
  v3_gray_800: '#2C2E30',
  v3_gray_900: '#0F0F10',

  v3_blue_100: '#F5FAFF',
  v3_blue_150: '#CCE8FF',
  v3_blue_200: '#8ECDFF',
  v3_blue_300: '#66BAFF',
  v3_blue_400: '#2BA0FF',
  v3_blue_500: '#0088F8',
  v3_blue_600: '#0072CE',
  v3_blue_700: '#005499',
  v3_blue_800: '#003A70',
  v3_blue_900: '#002847',

  v3_green_100: '#DFF9EA',
  v3_green_200: '#BFF7D7',
  v3_green_300: '#8EEBB5',
  v3_green_400: '#7EE0A7',
  v3_green_500: '#1AC662',
  v3_green_600: '#14994C',
  v3_green_700: '#007C34',

  v3_yellow_100: '#FFF5D6',
  v3_yellow_200: '#FFE18F',
  v3_yellow_300: '#FFD970',
  v3_yellow_400: '#FFCF4C',
  v3_yellow_500: '#FFC229',
  v3_yellow_600: '#F0A605',
  v3_yellow_700: '#BA4E00',

  v3_red_100: '#FFF6F5',
  v3_red_200: '#FFDCD6',
  v3_red_300: '#FFBAAD',
  v3_red_400: '#FF9785',
  v3_red_500: '#FF6347',
  v3_red_600: '#D11F00',
  v3_red_700: '#A31800',
  v3_red_800: '#7A1200',

  v3_teal_100: '#E3FCF8',
  v3_teal_200: '#BCF9EF',
  v3_teal_300: '#5DD8C3',
  v3_teal_400: '#30C0A8',
  v3_teal_500: '#1EA28C',
  v3_teal_600: '#0A7E6B',
  v3_teal_700: '#075F50',

  v3_pink_100: '#FDF1FD',
  v3_pink_200: '#FCE6FC',
  v3_pink_300: '#FFA9FA',
  v3_pink_400: '#F67CF2',
  v3_pink_500: '#D94AE1',
  v3_pink_600: '#B229B9',
  v3_pink_700: '#891F8E',

  v3_violet_100: '#EFEBFF',
  v3_violet_200: '#E2D9FF',
  v3_violet_300: '#C9B8FF',
  v3_violet_400: '#AE95FF',
  v3_violet_500: '#8E6CFE',
  v3_violet_600: '#6C49E1',
  v3_violet_700: '#4C23D2',

  inherit: 'inherit',
  transparent: 'transparent',
  /* eslint-enable sort-keys, @typescript-eslint/naming-convention */
};

export const getColorVariable = (colorKey: ColorKey | undefined): string | undefined =>
  colorKey ? `var(--color-${colorKey})` : undefined;

export interface PrimitiveColors {
  /* eslint-disable @typescript-eslint/naming-convention */
  blue_100: string;
  blue_150: string;
  blue_200: string;
  blue_300: string;
  blue_400: string;
  blue_500: string;
  blue_600: string;
  blue_700: string;
  blue_800: string;
  blue_900: string;
  brown_100: string;
  brown_200: string;
  brown_300: string;
  brown_400: string;
  brown_450: string;
  brown_500: string;
  brown_550: string;
  brown_600: string;
  brown_700: string;
  brown_800: string;
  brown_900: string;
  danger_100: string;
  danger_200: string;
  danger_300: string;
  danger_400: string;
  danger_500: string;
  danger_600: string;
  danger_700: string;
  danger_800: string;
  green_100: string;
  green_150: string;
  green_200: string;
  green_300: string;
  green_400: string;
  green_500: string;
  green_600: string;
  green_700: string;
  green_800: string;
  green_900: string;
  iris_300: string;
  iris_600: string;
  iris_800: string;
  navy_0: string;
  navy_100: string;
  navy_200: string;
  navy_300: string;
  navy_400: string;
  navy_450: string;
  navy_500: string;
  navy_550: string;
  navy_600: string;
  navy_700: string;
  navy_800: string;
  navy_900: string;
  overlays_scrim: string;
  overlays_thumbnail: string;
  pink_100: string;
  pink_200: string;
  pink_300: string;
  pink_400: string;
  pink_500: string;
  pink_600: string;
  pink_700: string;
  smoke_0: string;
  smoke_100: string;
  smoke_200: string;
  smoke_300: string;
  smoke_400: string;
  smoke_50: string;
  smoke_500: string;
  smoke_600: string;
  smoke_700: string;
  smoke_800: string;
  smoke_900: string;
  success_100: string;
  success_200: string;
  success_300: string;
  success_400: string;
  success_500: string;
  success_600: string;
  success_700: string;
  teal_100: string;
  teal_200: string;
  teal_300: string;
  teal_400: string;
  teal_500: string;
  teal_600: string;
  teal_700: string;
  triumph_teal_100: string;
  triumph_teal_200: string;
  triumph_teal_300: string;
  triumph_teal_400: string;
  triumph_teal_50: string;
  triumph_teal_500: string;
  triumph_teal_600: string;
  triumph_teal_700: string;
  triumph_teal_800: string;
  triumph_teal_900: string;
  violet_100: string;
  violet_200: string;
  violet_300: string;
  violet_400: string;
  violet_500: string;
  violet_600: string;
  violet_700: string;
  warning_100: string;
  warning_200: string;
  warning_300: string;
  warning_400: string;
  warning_500: string;
  warning_600: string;
  warning_700: string;
  /* eslint-enable @typescript-eslint/naming-convention */
}

export interface SemanticColors {
  /* eslint-disable @typescript-eslint/naming-convention */
  background_product: string;
  badge_button_count_background: string;
  badge_button_text: string;
  border_default: string;
  border_disabled: string;
  border_focus: string;
  border_hover: string;
  border_selected: string;
  box_shadow: string;
  brand_0: string;
  brand_100: string;
  brand_150: string;
  brand_200: string;
  brand_300: string;
  brand_400: string;
  brand_500: string;
  brand_600: string;
  brand_700: string;
  brand_800: string;
  brand_900: string;
  button_active: string;
  button_default: string;
  button_disabled: string;
  button_hover: string;
  button_secondary_border: string;
  button_secondary_text_active: string;
  button_secondary_text_default: string;
  button_secondary_text_disabled: string;
  button_secondary_text_hover: string;
  button_tertiary_text_default: string;
  button_text_active: string;
  button_text_default: string;
  button_text_disabled: string;
  button_text_hover: string;
  calender_day_range_background: string;
  card_background: string;
  card_border: string;
  contact_info_list_item_selected_background: string;
  content_tabs_active_background: string;
  content_tabs_background: string;
  content_tabs_text: string;
  danger_button_active: string;
  danger_button_default: string;
  danger_button_disabled: string;
  danger_button_hover: string;
  danger_button_secondary_text_active: string;
  danger_button_secondary_text_default: string;
  danger_button_secondary_text_disabled: string;
  danger_button_secondary_text_hover: string;
  danger_button_text_active: string;
  danger_button_text_default: string;
  danger_button_text_disabled: string;
  danger_button_text_hover: string;
  date_picker_header_background: string;
  descriptor_tag_error_background: string;
  descriptor_tag_error_border: string;
  descriptor_tag_error_text: string;
  descriptor_tag_info_background: string;
  descriptor_tag_info_border: string;
  descriptor_tag_info_text: string;
  descriptor_tag_neutral_background: string;
  descriptor_tag_neutral_border: string;
  descriptor_tag_neutral_text: string;
  descriptor_tag_success_background: string;
  descriptor_tag_success_border: string;
  descriptor_tag_success_text: string;
  descriptor_tag_warning_background: string;
  descriptor_tag_warning_border: string;
  descriptor_tag_warning_text: string;
  disabled_overlay: string;
  divider: string;
  grayscale_0: string;
  grayscale_100: string;
  grayscale_200: string;
  grayscale_300: string;
  grayscale_400: string;
  grayscale_450: string;
  grayscale_500: string;
  grayscale_550: string;
  grayscale_600: string;
  grayscale_700: string;
  grayscale_800: string;
  grayscale_900: string;
  icon_active: string;
  icon_danger: string;
  icon_default: string;
  icon_disabled: string;
  icon_info: string;
  icon_neutral: string;
  icon_success: string;
  icon_utility: string;
  icon_warning: string;
  icon_white: string;
  input_background_default: string;
  input_background_disabled: string;
  input_border_danger: string;
  input_border_default: string;
  input_border_focus_danger: string;
  input_border_focus_default: string;
  input_placeholder: string;
  insights_graph_grid_line: string;
  insights_graph_line_primary: string;
  insights_graph_tick_text: string;
  insights_legend_text: string;
  invoice_status_tracker_active_background: string;
  invoice_status_tracker_default_status_border: string;
  invoice_status_tracker_future_status_pill: string;
  jewel: string;
  key_value_pair_hightlighted_text: string;
  menu_item_border_bottom: string;
  menu_item_disabled_background: string;
  menu_item_disabled_text: string;
  menu_item_focus_background: string;
  menu_item_li_hover_background: string;
  menu_item_selected_background: string;
  menu_item_selected_focus_background: string;
  menu_item_text: string;
  nav_background: string;
  nav_border: string;
  nav_item_active_background: string;
  nav_item_hover: string;
  notification_danger_background: string;
  notification_danger_border: string;
  notification_info_background: string;
  notification_info_border: string;
  notification_success_background: string;
  notification_success_border: string;
  notification_warning_background: string;
  notification_warning_border: string;
  progress_bar_error: string;
  progress_bar_warning: string;
  promo_ch_robinson: string;
  queue_tabs_background: string;
  scrim_overlay: string;
  sidenav_background: string;
  skeleton_background: string;
  skeleton_foreground: string;
  status_blue: string;
  status_green: string;
  status_pink: string;
  status_red: string;
  status_teal: string;
  status_text: string;
  status_text_outlined: string;
  status_violet: string;
  status_yellow: string;
  system_notification_danger: string;
  system_notification_warning: string;
  table_background: string;
  table_divider: string;
  table_filter_drawer_background: string;
  table_head_hover_background: string;
  table_pinned_column_border: string;
  table_pinned_column_box_shadow: string;
  table_resize_handle: string;
  table_row_even_background: string;
  table_row_odd_background: string;
  text_active: string;
  text_branded: string;
  text_default: string;
  text_disabled: string;
  text_error: string;
  text_inverted: string;
  text_light: string;
  text_link: string;
  text_success: string;
  text_warning: string;
  utility_button_border_default: string;
  utility_button_border_hover: string;
  utility_button_fill_active: string;
  utility_button_fill_hover: string;
  utility_button_icon_default: string;

  /* eslint-enable @typescript-eslint/naming-convention */
}

export type SemanticColorKey = keyof SemanticColors;

export const getSemanticColorVariable = (
  semanticColorKey: 'transparent' | SemanticColorKey | undefined,
): string | undefined => {
  if (semanticColorKey === 'transparent') {
    return 'transparent';
  }

  return semanticColorKey ? `var(--color-${semanticColorKey})` : undefined;
};

export const primitiveColors: PrimitiveColors = {
  /* eslint-disable @typescript-eslint/naming-convention */
  blue_100: 'hsl(210 100% 98%)',
  blue_150: 'hsl(207 100% 90%)',
  blue_200: 'hsl(207 100% 78%)',
  blue_300: 'hsl(207 100% 70%)',
  blue_400: 'hsl(207 100% 58%)',
  blue_500: 'hsl(207 100% 51%)',
  blue_600: 'hsl(207 100% 40%)',
  blue_700: 'hsl(207 100% 30%)',
  blue_800: 'hsl(209 100% 22%)',
  blue_900: 'hsl(206 100% 14%)',

  brown_100: 'hsl(30 9% 98%)',
  brown_200: 'hsl(30 14% 96%)',
  brown_300: 'hsl(30 14% 89%)',
  brown_400: 'hsl(30 10% 80%)',
  brown_450: 'hsl(30 8% 72%)',
  brown_500: 'hsl(30 6% 55%)',
  brown_550: 'hsl(28 6% 47%)',
  brown_600: 'hsl(30 7% 39%)',
  brown_700: 'hsl(32 8% 32%)',
  brown_800: 'hsl(30 8% 24%)',
  brown_900: 'hsl(36 8% 12%)',

  danger_100: 'hsl(9 100% 98%)',
  danger_200: 'hsl(9 100% 92%)',
  danger_300: 'hsl(9 100% 84%)',
  danger_400: 'hsl(9 100% 76%)',
  danger_500: 'hsl(9 100% 64%)',
  danger_600: 'hsl(9 100% 41%)',
  danger_700: 'hsl(9 100% 32%)',
  danger_800: 'hsl(9 100% 24%)',

  green_100: 'hsl(148 38% 92%)',
  green_150: 'hsl(148 39% 84%)',
  green_200: 'hsl(155 38% 68%)',
  green_300: 'hsl(158 38% 52%)',
  green_400: 'hsl(164 55% 41%)',
  green_500: 'hsl(164 64% 30%)',
  green_600: 'hsl(164 73% 25%)',
  green_700: 'hsl(164 74% 21%)',
  green_800: 'hsl(151 59% 14%)',
  green_900: 'hsl(157 87% 9%)',

  iris_300: 'hsl(253 70% 95%)',
  iris_600: 'hsl(253 65% 39%)',
  iris_800: 'hsl(250 55% 17%)',

  navy_0: 'hsl(0 0% 100%)',
  navy_100: 'hsl(218 42% 98%)',
  navy_200: 'hsl(220 33% 96%)',
  navy_300: 'hsl(213 27% 92%)',
  navy_400: 'hsl(211 28% 85%)',
  navy_450: 'hsl(208 20% 73%)',
  navy_500: 'hsl(209 19% 63%)',
  navy_550: 'hsl(209 19% 53%)',
  navy_600: 'hsl(209 20% 43%)',
  navy_700: 'hsl(209 30% 28%)',
  navy_800: 'hsl(209 40% 17%)',
  navy_900: 'hsl(204 80% 8%)',

  overlays_scrim: 'hsl(203 70% 10% / 0.3)',

  overlays_thumbnail: 'hsl(207 100% 40% / 0.16)',

  pink_100: 'hsl(300 79% 97%)',
  pink_200: 'hsl(300 78% 94%)',
  pink_300: 'hsl(303 100% 83%)',
  pink_400: 'hsl(302 87% 73%)',
  pink_500: 'hsl(297 72% 59%)',
  pink_600: 'hsl(297 64% 44%)',
  pink_700: 'hsl(297 64% 34%)',

  smoke_0: 'hsl(0 0% 100%)',
  smoke_50: 'hsl(210 17% 98%)',
  smoke_100: 'hsl(210 8% 95%)',
  smoke_200: 'hsl(210 6% 93%)',
  smoke_300: 'hsl(210 8% 95%)',
  smoke_400: 'hsl(210 5% 63%)',
  smoke_500: 'hsl(210 4% 44%)',
  smoke_600: 'hsl(213 7% 31%)',
  smoke_700: 'hsl(213 9% 20%)',
  smoke_800: 'hsl(218 13% 12%)',
  smoke_900: 'hsl(223 26% 5%)',

  success_100: 'hsl(145 67% 94%)',
  success_200: 'hsl(146 78% 86%)',
  success_300: 'hsl(145 70% 74%)',
  success_400: 'hsl(145,61%,69%)',
  success_500: 'hsl(145 77% 44%)',
  success_600: 'hsl(145 77% 34%)',
  success_700: 'hsl(145 100% 24%)',

  teal_100: 'hsl(170 84% 94%)',
  teal_200: 'hsl(170 83% 86%)',
  teal_300: 'hsl(170 61% 61%)',
  teal_400: 'hsl(170 60% 47%)',
  teal_500: 'hsl(170 69% 38%)',
  teal_600: 'hsl(170 85% 27%)',
  teal_700: 'hsl(170 85% 20%)',

  triumph_teal_50: 'hsl(189 63% 94%)',
  triumph_teal_100: 'hsl(188 59% 87%)',
  triumph_teal_200: 'hsl(188 59% 75%)',
  triumph_teal_300: 'hsl(189 60% 63%)',
  triumph_teal_400: 'hsl(189 60% 50%)',
  triumph_teal_500: 'hsl(188 100% 37%)',
  triumph_teal_600: 'hsl(191 100% 30%)',
  triumph_teal_700: 'hsl(193 100% 24%)',
  triumph_teal_800: 'hsl(198 100% 18%)',
  triumph_teal_900: 'hsl(207 100% 12%)',

  violet_100: 'hsl(254 100% 96%)',
  violet_200: 'hsl(254 100% 93%)',
  violet_300: 'hsl(254 100% 86%)',
  violet_400: 'hsl(254 100% 79%)',
  violet_500: 'hsl(254 99% 71%)',
  violet_600: 'hsl(254 72% 58%)',
  violet_700: 'hsl(254 72% 48%)',

  warning_100: 'hsl(45 100% 94%)',
  warning_200: 'hsl(44 100% 78%)',
  warning_300: 'hsl(44 100% 72%)',
  warning_400: 'hsl(44 100% 65%)',
  warning_500: 'hsl(43 100% 58%)',
  warning_600: 'hsl(41 96% 48%)',
  warning_700: 'hsl(25 100% 36%)',
  /* eslint-enable @typescript-eslint/naming-convention */
};

export const semanticColors: SemanticColors = {
  /* eslint-disable @typescript-eslint/naming-convention */
  background_product: 'var(--color-smoke_50)',

  badge_button_count_background: 'hsla(0, 0%, 100%, 0.38)',
  badge_button_text: 'var(--color-navy_900)',

  border_default: 'var(--color-navy_400)',
  border_disabled: 'var(--color-navy_300)',
  border_focus: 'var(--color-navy_900)',
  border_hover: 'var(--color-navy_500)',
  border_selected: 'var(--color-triumph_teal_600)',

  box_shadow: 'var(--color-gray_400)',

  brand_0: 'var(--color-navy_0)',
  brand_100: 'var(--color-triumph_teal_100)',
  brand_150: 'var(--color-triumph_teal_150)',
  brand_200: 'var(--color-triumph_teal_200)',
  brand_300: 'var(--color-triumph_teal_300)',
  brand_400: 'var(--color-triumph_teal_400)',
  brand_500: 'var(--color-triumph_teal_500)',
  brand_600: 'var(--color-triumph_teal_600)',
  brand_700: 'var(--color-triumph_teal_700)',
  brand_800: 'var(--color-triumph_teal_800)',
  brand_900: 'var(--color-triumph_teal_900)',

  button_active: 'var(--color-triumph_teal_800)',
  button_default: 'var(--color-triumph_teal_500)',
  button_disabled: 'var(--color-navy_300)',
  button_hover: 'var(--color-triumph_teal_700)',
  button_secondary_border: 'var(--color-triumph_teal_500)',
  button_secondary_text_active: 'var(--color-triumph_teal_800)',
  button_secondary_text_default: 'var(--color-triumph_teal_500)',
  button_secondary_text_disabled: 'var(--color-navy_500)',
  button_secondary_text_hover: 'var(--color-triumph_teal_700)',
  button_tertiary_text_default: 'var(--color-triumph_teal_500)',
  button_text_active: 'var(--color-navy_0)',
  button_text_default: 'var(--color-navy_0)',
  button_text_disabled: 'var(--color-navy_500)',
  button_text_hover: 'var(--color-navy_0)',

  calender_day_range_background: 'var(--color-navy_200)',

  card_background: 'var(--color-navy_0)',
  card_border: 'var(--color-navy_300)',

  contact_info_list_item_selected_background: 'var(--color-triumph_teal_150)',

  content_tabs_active_background: 'var(--color-navy_0)',
  content_tabs_background: 'var(--color-navy_400)',
  content_tabs_text: 'var(--color-smoke_800)',

  danger_button_active: 'var(--color-danger_800)',
  danger_button_default: 'var(--color-danger_600)',
  danger_button_disabled: 'var(--color-navy_300)',
  danger_button_hover: 'var(--color-danger_700)',
  danger_button_secondary_text_active: 'var(--color-danger_800)',
  danger_button_secondary_text_default: 'var(--color-danger_600)',
  danger_button_secondary_text_disabled: 'var(--color-navy_500)',
  danger_button_secondary_text_hover: 'var(--color-danger_700)',
  danger_button_text_active: 'var(--color-navy_0)',
  danger_button_text_default: 'var(--color-navy_0)',
  danger_button_text_disabled: 'var(--color-navy_500)',
  danger_button_text_hover: 'var(--color-navy_0)',

  date_picker_header_background: 'var(--color-brand_600)',

  descriptor_tag_error_background: 'var(--color-danger_100)',
  descriptor_tag_error_border: 'var(--color-danger_400)',
  descriptor_tag_error_text: 'var(--color-danger_700)',
  descriptor_tag_info_background: 'var(--color-triumph_teal_100)',
  descriptor_tag_info_border: 'var(--color-triumph_teal_400)',
  descriptor_tag_info_text: 'var(--color-triumph_teal_700)',
  descriptor_tag_neutral_background: 'var(--color-navy_100)',
  descriptor_tag_neutral_border: 'var(--color-navy_400)',
  descriptor_tag_neutral_text: 'var(--color-navy_700)',
  descriptor_tag_success_background: 'var(--color-success_100)',
  descriptor_tag_success_border: 'var(--color-success_400)',
  descriptor_tag_success_text: 'var(--color-success_700)',
  descriptor_tag_warning_background: 'var(--color-warning_100)',
  descriptor_tag_warning_border: 'var(--color-warning_400)',
  descriptor_tag_warning_text: 'var(--color-warning_700)',

  disabled_overlay: 'var(--color-navy_100)',

  divider: 'var(--color-navy_300)',

  grayscale_0: 'var(--color-navy_0)',
  grayscale_100: 'var(--color-navy_100)',
  grayscale_200: 'var(--color-navy_200)',
  grayscale_300: 'var(--color-navy_300)',
  grayscale_400: 'var(--color-navy_400)',
  grayscale_450: 'var(--color-navy_450)',
  grayscale_500: 'var(--color-navy_500)',
  grayscale_550: 'var(--color-navy_550)',
  grayscale_600: 'var(--color-navy_600)',
  grayscale_700: 'var(--color-navy_700)',
  grayscale_800: 'var(--color-navy_800)',
  grayscale_900: 'var(--color-navy_900)',

  icon_active: 'var(--color-iris_600)',
  icon_danger: 'var(--color-danger_600)',
  icon_default: 'var(--color-navy_900)',
  icon_disabled: 'var(--color-navy_400)',
  icon_info: 'var(--color-triumph_teal_600)',
  icon_neutral: 'var(--color-navy_450)',
  icon_success: 'var(--color-success_600)',
  icon_utility: 'var(--color-smoke_600)',
  icon_warning: 'var(--color-warning_500)',
  icon_white: 'var(--color-navy_0)',

  input_background_default: 'var(--color-navy_0)',
  input_background_disabled: 'var(--color-navy_200)',
  input_border_danger: 'var(--color-danger_400)',
  input_border_default: 'var(--color-navy_400)',
  input_border_focus_danger: 'var(--color-danger_600)',
  input_border_focus_default: 'var(--color-navy_900)',
  input_placeholder: 'var(--color-navy_500)',

  insights_graph_grid_line: 'var(--color-navy_200)',
  insights_graph_line_primary: 'var(--color-triumph_teal_600)',
  insights_graph_tick_text: 'var(--color-navy_600)',
  insights_legend_text: 'var(--color-navy_700)',

  invoice_status_tracker_active_background: 'var(--color-navy_200)',
  invoice_status_tracker_default_status_border: 'var(--color-triumph_teal_800)',
  invoice_status_tracker_future_status_pill: 'var(--color-navy_600)',

  jewel: 'var(--color-danger_600)',

  key_value_pair_hightlighted_text: 'var(--color-navy_900)',

  menu_item_border_bottom: 'var(--color-navy_300)',
  menu_item_disabled_background: 'var(--color-navy_100)',
  menu_item_disabled_text: 'var(--color-navy_500)',
  menu_item_focus_background: 'var(--color-triumph_teal_100)',
  menu_item_li_hover_background: 'var(--color-navy_0)',
  menu_item_selected_background: 'var(--color-triumph_teal_200)',
  menu_item_selected_focus_background: 'var(--color-triumph_teal_300)',
  menu_item_text: 'var(--color-navy_900)',

  nav_background: 'var(--color-iris_800)',
  nav_border: 'var(--color-smoke_200)',
  nav_item_active_background: 'hsla(253, 76%, 48%, 0.1)',
  nav_item_hover: 'hsla(253, 76%, 48%, 0.4)',

  notification_danger_background: 'var(--color-danger_200)',
  notification_danger_border: 'var(--color-danger_300)',
  notification_info_background: 'hsla(188, 100%, 30%, 0.06)',
  notification_info_border: 'hsla(188, 100%, 30%, 0.2)',
  notification_success_background: 'var(--color-success_100)',
  notification_success_border: 'var(--color-success_400)',
  notification_warning_background: 'var(--color-warning_100)',
  notification_warning_border: 'var(--color-warning_300)',

  progress_bar_error: 'var(--color-danger_600)',
  progress_bar_warning: 'var(--color-warning_500)',

  promo_ch_robinson: '#004986',

  queue_tabs_background: 'var(--color-navy_100)',

  scrim_overlay: 'var(--color-overlays_scrim)',

  sidenav_background: 'var(--color-smoke_0)',

  skeleton_background: 'var(--color-navy_300)',
  skeleton_foreground: 'var(--color-navy_200)',

  status_blue: 'var(--color-triumph_teal_200)',
  status_green: 'var(--color-success_400)',
  status_pink: 'var(--color-pink_300)',
  status_red: 'var(--color-danger_400)',
  status_teal: 'var(--color-teal_300)',
  status_text: 'var(--color-navy_900)',
  status_text_outlined: 'var(--color-navy_900)',
  status_violet: 'var(--color-violet_300)',
  status_yellow: 'var(--color-warning_400)',

  system_notification_danger: 'var(--color-danger_400)',
  system_notification_warning: 'var(--color-warning_400)',

  table_background: 'var(--color-navy_0)',
  table_divider: 'var(--color-navy_400)',
  table_filter_drawer_background: 'var(--color-navy_0)',
  table_head_hover_background: 'var(--color-navy_100)',
  table_pinned_column_border: 'var(--color-navy_400)',
  table_pinned_column_box_shadow: '#0028471a',
  table_resize_handle: 'var(--color-triumph_teal_200)',
  table_row_even_background: 'var(--color-navy_100)',
  table_row_odd_background: 'var(--color-navy_0)',

  text_active: 'var(--color-iris_600)',
  text_branded: 'var(--color-triumph_teal_600)',
  text_default: 'var(--color-smoke_800)',
  text_disabled: 'var(--color-navy_500)',
  text_error: 'var(--color-danger_700)',
  text_inverted: 'var(--color-navy_0)',
  text_light: 'var(--color-smoke_600)',
  text_link: 'var(--color-triumph_teal_500)',
  text_success: 'var(--color-success_700)',
  text_warning: 'var(--color-warning_700)',

  utility_button_border_default: 'var(--color-navy_400)',
  utility_button_border_hover: 'var(--color-triumph_teal_600)',
  utility_button_fill_active: 'var(--color-navy_400)',
  utility_button_fill_hover: 'var(--color-navy_200)',
  utility_button_icon_default: 'var(--color-navy_600)',
  /* eslint-enable @typescript-eslint/naming-convention */
};
